import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.MediaSchedules = routerStyxie({ actions: ['show']})
